import { jsx } from "panel";
import { ButtonEl } from "common/components/button";
import { SvgIconEl } from "common/components/svg-icon";
import { TooltipEl } from "common/components/tooltip";
import { DisplaySize, Placement } from "common/components/tooltip/types";
import { hasSlot } from "common/util/dom";
import { formatText } from "common/util/format-text";
import { ButtonTheme } from "../button/constants";
import { getIcon } from "./helpers";
import { getImage } from "./helpers";
const BodyTextClassName = `banner-body`;
function getTooltip(bannerTooltip) {
  return bannerTooltip ? /* @__PURE__ */ jsx("div", { sel: ".banner-tooltip" }, /* @__PURE__ */ jsx(
    "a",
    {
      attrs: {
        href: bannerTooltip.href
      }
    },
    bannerTooltip.text
  ), /* @__PURE__ */ jsx(
    TooltipEl,
    {
      attrs: {
        elref: `bannerTooltip`,
        placement: Placement.Top,
        size: DisplaySize.Small
      },
      props: {
        // It is important to explicitly null this out, otherwise the content
        // from the other TooltipEl from renderTooltip will be rendered in
        // the tooltip.
        lazyContentRenderer: null
      }
    },
    /* @__PURE__ */ jsx("div", { sel: ".banner-info-tooltip" }, bannerTooltip.tooltipText)
  )) : null;
}
export function CoreBanner(banner, actionNode) {
  const tooltip = getTooltip(banner.attr(`tooltip`));
  let bodyTextNode = null;
  if (hasSlot(banner, `body-text`)) {
    bodyTextNode = /* @__PURE__ */ jsx(
      "slot",
      {
        sel: `.${BodyTextClassName}`,
        attrs: { name: `body-text` },
        class: {
          [`${banner.attr(`theme`)}-theme`]: true
        }
      }
    );
  } else if (banner.attr(`body-text`)) {
    bodyTextNode = /* @__PURE__ */ jsx(
      "div",
      {
        sel: `.${BodyTextClassName}`,
        class: {
          [`${banner.attr(`theme`)}-theme`]: true
        }
      },
      formatText(banner.attr(`body-text`), {}, tooltip ? [tooltip] : [])
    );
  }
  return /* @__PURE__ */ jsx(
    "div",
    {
      sel: ".banner-wrapper",
      class: {
        [`${banner.attr(`type`)}-type`]: true,
        [`${banner.attr(`theme`)}-theme`]: true,
        [`has-image`]: !!banner.attr(`img-src`)
      }
    },
    /* @__PURE__ */ jsx(
      "div",
      {
        sel: ".banner-panel",
        class: {
          "has-cta": !!actionNode,
          [`${banner.attr(`size`)}-size`]: true,
          [`${banner.attr(`theme`)}-theme`]: true,
          [`${banner.attr(`type`)}-type`]: true,
          [`has-image`]: !!banner.attr(`img-src`),
          "body-only": Boolean(bodyTextNode) && !banner.attr(`header-text`)
        }
      },
      getImage(banner) ? /* @__PURE__ */ jsx("img", { sel: ".banner-image", attrs: { src: getImage(banner) } }) : getIcon(banner) ? /* @__PURE__ */ jsx(
        SvgIconEl,
        {
          sel: ".banner-title-icon",
          attrs: {
            icon: getIcon(banner)
          },
          class: { "banner-copy-no-header": !banner.attr(`header-text`) }
        }
      ) : null,
      /* @__PURE__ */ jsx(
        "div",
        {
          sel: ".banner-content",
          class: {
            [`${banner.attr(`theme`)}-theme`]: true
          }
        },
        /* @__PURE__ */ jsx(
          "div",
          {
            sel: ".banner-copy",
            class: {
              "banner-copy-no-header": !banner.attr(`header-text`),
              [`${banner.attr(`theme`)}-theme`]: true
            }
          },
          banner.attr(`header-text`) ? /* @__PURE__ */ jsx("header", { sel: ".banner-header", class: { [`${banner.attr(`theme`)}-theme`]: true } }, banner.attr(`header-text`)) : null,
          bodyTextNode,
          banner.attr(`footer-text`) ? /* @__PURE__ */ jsx("footer", { sel: ".banner-footer" }, banner.attr(`footer-text`)) : null
        ),
        actionNode ? /* @__PURE__ */ jsx(
          "div",
          {
            sel: ".banner-actions",
            class: {
              [`${banner.attr(`theme`)}-theme`]: true
            }
          },
          actionNode
        ) : null
      )
    )
  );
}
export function template() {
  const hasCta = this.attr(`ctas`) && this.attr(`ctas`).length > 0;
  const ctaNode = hasCta ? /* @__PURE__ */ jsx(null, null, this.attr(`ctas`).map((cta) => {
    const isEmbedded = this.attr(`type`) === this.helpers.BannerType.Embedded;
    const isSmall = this.attr(`size`) === this.helpers.BannerSize.Small;
    const embeddedTheme = isSmall ? ButtonTheme.Tertiary : ButtonTheme.Secondary;
    const shownTheme = cta.theme || (isEmbedded ? embeddedTheme : void 0);
    const shouldShowXIcon = isSmall && cta.actionName === this.helpers.BannerAction.Dismiss;
    return /* @__PURE__ */ jsx(
      ButtonEl,
      {
        sel: ".cta-button",
        attrs: {
          theme: shownTheme,
          icon: shouldShowXIcon ? `x` : cta.icon,
          type: this.helpers.getButtonType()
        },
        class: {
          "banner-action-button-embedded": isEmbedded,
          [`${this.attr(`theme`)}-theme`]: true
        },
        on: { click: () => this.helpers.handleCtaButtonClick(cta) }
      },
      !shouldShowXIcon ? cta.text : null
    );
  })) : null;
  return CoreBanner(this, ctaNode);
}
